import { LegalLayout } from '../components/legal/LegalLayout';

export default function PrivacyPolicy() {
  const sections = [
    {
      heading: 'Information We Collect',
      body: [
        'We collect information you provide directly to us, as well as certain information automatically when you use our website and programs.',
      ],
      items: [
        'Information you provide: your name, email address, phone number, and any details you share when you enroll in a program, complete an assessment, contact us, or use our chat widget.',
        'Payment information: when you purchase a program, payment is processed by our third-party payment and program providers. We do not store full payment card details on our servers.',
        'Automatically collected information: your IP address, browser type, device information, pages visited, and usage activity, collected through cookies and similar technologies.',
      ],
    },
    {
      heading: 'How We Use Your Information',
      body: ['We use the information we collect to:'],
      items: [
        'Provide, deliver, and improve our grief education programs and services.',
        'Communicate with you about enrollment, scheduling, updates, and support.',
        'Respond to your inquiries and messages sent through forms or the chat widget.',
        'Send you relevant program information and offers (you may opt out at any time).',
        'Analyze website usage to improve content and user experience.',
        'Comply with legal obligations and protect our rights.',
      ],
    },
    {
      heading: 'Cookies & Analytics',
      body: [
        'We use cookies and similar tracking technologies to operate our website, remember your preferences, and understand how visitors interact with our content. We also use analytics tools and a live chat widget provided by third parties. You can control cookies through your browser settings, though disabling them may affect certain features.',
      ],
    },
    {
      heading: 'How We Share Your Information',
      body: [
        'We do not sell your personal information. We may share information with trusted third-party service providers who help us operate our business — such as payment processors, course/program platforms, email and communication tools, and analytics providers — solely to perform services on our behalf. We may also disclose information when required by law or to protect the rights, safety, and property of Dr. Angelia Griffin Grief Coaching, AGC LLC, or others.',
      ],
    },
    {
      heading: 'Data Security',
      body: [
        'We take reasonable administrative, technical, and physical measures to protect your personal information. However, no method of transmission over the internet or electronic storage is completely secure, and we cannot guarantee absolute security.',
      ],
    },
    {
      heading: 'Your Rights & Choices',
      body: ['Depending on your location, you may have the right to:'],
      items: [
        'Access, correct, or request deletion of your personal information.',
        'Opt out of marketing communications by using the unsubscribe link or contacting us.',
        'Request information about how your data is processed.',
      ],
    },
    {
      heading: 'Third-Party Links',
      body: [
        'Our website and programs may contain links to third-party websites, assessments, and platforms that we do not control. This Privacy Policy does not apply to those third-party sites, and we encourage you to review their privacy policies.',
      ],
    },
    {
      heading: "Children's Privacy",
      body: [
        'Our services are intended for adults. We do not knowingly collect personal information from children under 18. If you believe a child has provided us information, please contact us so we can remove it.',
      ],
    },
    {
      heading: 'Changes to This Policy',
      body: [
        'We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Last updated" date. Your continued use of our website and services constitutes acceptance of the revised policy.',
      ],
    },
    {
      heading: 'Contact Us',
      body: [
        'If you have questions about this Privacy Policy or how we handle your information, please contact us at info@agcthefixer.com or (770) 422-4048.',
      ],
    },
  ];

  return (
    <LegalLayout
      testId="privacy-policy-page"
      title="Privacy Policy"
      lastUpdated="December 2025"
      intro="Dr. Angelia Griffin Grief Coaching (operated by AGC LLC) respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains what information we collect, how we use it, and the choices you have."
      sections={sections}
    />
  );
}
